var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('h6',[_vm._v(_vm._s(_vm.orders.title))]),_c('span',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.orders.body.msg.replace(/_/g, " ")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }